/**************************************************************************************************/
/** @import Constants                                                                            **/
/**************************************************************************************************/
import { Component } from '@/Constants/Component'

/**************************************************************************************************/
/** @export Class @name FieldsOptions                                                            **/
/**************************************************************************************************/
export default class FieldsOptions
{
	/*************************************************/
	/** @Properties                                 **/
	/*************************************************/
	private _lastKey: string
	public options: { [key: string]: any }

	/*************************************************/
	/** @Constructor                                **/
	/*************************************************/
	constructor()
	{
		this.options = {}
	}

	/*************************************************/
	/** @Methods                                    **/
	/*************************************************/
	private _getLastOption() : any
	{
		return this.options[this._lastKey]
	}

	public add(key: string, label?: string) : this
	{
		this._lastKey = key
		this.options[this._lastKey] = { label }
		this.setStyle(Component.VueComponents.Global.DataTable.DefaultThStyle)
		return this
	}

	public ignoreSpecialChars() : this
	{
		this._getLastOption().ignoreSpecialChars = true
		return this
	}

	public isSortable() : this
	{
		this._getLastOption().sortable = true
		return this
	}

	public setAlign(field?: string, item?: string) : this
	{
		this._getLastOption().align = { field, item }
		return this
	}

	public setCheckBox(options: CheckBoxOptions = {}) : this
	{
		this._getLastOption().checkbox = { ...options }
		this._getLastOption().checkbox.editable = true
		return this
	}

	public setContentStyle(contentStyle: string, callback?: (item: any) => boolean) : this
	{
		const option = this._getLastOption()
		option.contentStyle = contentStyle
		if (callback) option.contentCallback = callback
		return this
	}

	public setEditable(options: EditableOptions = {}) : this
	{
		this._getLastOption().entry = { ...options }
		this._getLastOption().entry.editable = true
		return this
	}

	public setIcon(icon: string | [string, string]) : this
	{
		this._getLastOption().icon = icon
		return this
	}

	public setSearchKey(key: string) : this
	{
		this._getLastOption().searchKey = key
		return this
	}

	public setSortDirection(sort: string) : this
	{
		this._getLastOption().sortDirection = sort
		return this
	}

	public setStyle(style: object) : this
	{
		const option = this._getLastOption()
		if (!option.thStyle) option.thStyle = { ...style }
		return this
	}

	public setStyleTh(style: any) : this
	{
		const option = this._getLastOption()
		if (!option.thStyle) option.thStyle = {}
		if ('width' in style) option.thStyle.width = style.width
		return this
	}

	public setTitle(title: string) : this
	{
		this._getLastOption().title = title
		return this
	}

	public showDetailsButton() : this
	{
		this._getLastOption().showDetailsButton = true
		return this
	}
}

/**************************************************************************************************/
/** @export Type @name CheckBoxOptions                                                           **/
/**************************************************************************************************/
export type CheckBoxOptions =
{
	readonly?: boolean
}

/**************************************************************************************************/
/** @export Type @name EditableOptions                                                           **/
/**************************************************************************************************/
export type EditableOptions =
{
	hint?: string
	restoreOnClear?: boolean
}